export default "__VITE_ASSET__C623jOb4__"